
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

/* ============================================================
   DATA
============================================================ */

const THEATER_DATA = {
  Navalur: {
    "Bliss Theatre": [
      { type: "image", src: "/images/gallery01.jpg", label: "Main Screen" },
      { type: "image", src: "/images/gallery02.jpg", label: "Couple Seating" },
      { type: "image", src: "/images/gallery03.jpg", label: "Lounge" },
      { type: "image", src: "/images/gallery11.jpg", label: "Lounge" },
    ],

    "HexaPlay Theatre": [
      { type: "image", src: "/images/gallery11.jpg", label: "Hall A" },
      { type: "image", src: "/images/gallery05.jpg", label: "Hall B" },
      { type: "image", src: "/images/gallery06.jpg", label: "Main Screen" },
      { type: "image", src: "/images/gallery07.jpg", label: "Seating Area" },
    ],

    "Fantasy Theatre": [
      { type: "image", src: "/images/gallery08.jpg", label: "Fantasy Hall" },
      { type: "image", src: "/images/gallery09.jpg", label: "VIP Zone" },
      { type: "image", src: "/images/gallery10.jpg", label: "Premium Screen" },
      { type: "image", src: "/images/gallery05.jpg", label: "Lounge" },
    ],
  },
};

const GAMES_DATA = [
  { type: "image", src: "/images/Gaming01.jpg", label: "PS5 Arena" },
  { type: "image", src: "/images/Gaming02.jpg", label: "Xbox Lounge" },
  { type: "image", src: "/images/Gaming03.jpg", label: "VR Zone" },
  { type: "image", src: "/images/Gaming04.jpg", label: "Retro Corner" },
  { type: "image", src: "/images/Gaming05.jpg", label: "Gaming PC" },
  { type: "image", src: "/images/Gaming06.jpg", label: "Console Setup" },
];

/* ============================================================
   ICONS
============================================================ */

const Icons = {
  MapPin: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),

  Camera: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  ),

  Play: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <polygon points="5 3 19 12 5 21" />
    </svg>
  ),

  ChevronDown: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
      strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),

  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),

  ArrowLeft: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),

  ArrowRight: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),

  Blog: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
      strokeLinejoin="round" aria-hidden="true">
      <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v17H6.5A2.5 2.5 0 0 0 4 21.5z" />
      <path d="M4 4.5v17" />
      <path d="M8 7h8" />
      <path d="M8 11h8" />
      <path d="M8 15h5" />
    </svg>
  ),
};

/* ============================================================
   DESKTOP CUSTOM SELECT
============================================================ */

function CustomSelect({
  label,
  icon: Icon,
  value,
  onChange,
  options,
  placeholder,
}) {
  return (
    <div className="custom-select-wrapper">
      <div className="select-icon-box">
        <Icon />
      </div>

      <div className="select-content">
        <span className="select-label">{label}</span>

        <select
          value={value}
          onChange={onChange}
          className="custom-select"
          aria-label={label}
        >
          <option value="" disabled>{placeholder}</option>

          {options.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      <div className="select-arrow">
        <Icons.ChevronDown />
      </div>
    </div>
  );
}

/* ============================================================
   MOBILE FILTER CARD
============================================================ */

function MobileFilterCard({ icon: Icon, label, value, options, onChange }) {
  return (
    <div className="m-filter-card">
      <div className="m-filter-icon-circle">
        <Icon />
      </div>

      <span className="m-filter-label">{label}</span>

      <select
        value={value}
        onChange={onChange}
        className="m-filter-native-select"
        aria-label={label}
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>

      <span className="m-filter-value">{value}</span>
    </div>
  );
}

/* ============================================================
   LIGHTBOX
============================================================ */

function Lightbox({ items, initialIndex, onClose, title }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % items.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") handleNext();
      if (e.key === "ArrowLeft") handlePrev();
    };

    const previousOverflow = document.body.style.overflow;

    window.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose, currentIndex]);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(null);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart === null || touchEnd === null) return;

    const distance = touchStart - touchEnd;

    if (Math.abs(distance) > 50) {
      if (distance > 0) handleNext();
      else handlePrev();
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  const currentItem = items[currentIndex];

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div
        className="lightbox-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="lb-close" onClick={onClose} aria-label="Close gallery">
          <Icons.Close />
        </button>

        <button
          className="lb-nav lb-prev lb-desktop-nav"
          onClick={handlePrev}
          aria-label="Previous image"
        >
          <Icons.ArrowLeft />
        </button>

        <div
          className="lb-media-container"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {currentItem.type === "video" ? (
            <video
              src={currentItem.src}
              controls
              autoPlay
              className="lb-media"
            />
          ) : (
            <img
              src={currentItem.src}
              alt={currentItem.label || "Gallery"}
              className="lb-media"
            />
          )}
        </div>

        <button
          className="lb-nav lb-next lb-desktop-nav"
          onClick={handleNext}
          aria-label="Next image"
        >
          <Icons.ArrowRight />
        </button>

        <div className="lb-mobile-bottom-bar">
          <button
            className="lb-mobile-nav-btn"
            onClick={handlePrev}
            aria-label="Previous image"
          >
            <Icons.ArrowLeft />
          </button>

          <div className="lb-mobile-counter-wrap">
            {title && <span className="lb-mobile-title">{title}</span>}
            <span className="lb-mobile-counter">
              {currentIndex + 1} / {items.length}
            </span>
          </div>

          <button
            className="lb-mobile-nav-btn"
            onClick={handleNext}
            aria-label="Next image"
          >
            <Icons.ArrowRight />
          </button>
        </div>

        <div className="lb-counter lb-desktop-counter">
          {currentIndex + 1} / {items.length}
        </div>

        {title && (
          <div className="lb-title-badge lb-desktop-title">{title}</div>
        )}

        <div className="lb-dots">
          {items.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Go to image ${i + 1}`}
              className={`lb-dot ${i === currentIndex ? "lb-dot-active" : ""}`}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

/* ============================================================
   MAIN GALLERY COMPONENT
============================================================ */

export default function GalleryPage() {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("theater");
  const [selectedLocation, setSelectedLocation] = useState("Navalur");
  const [selectedTheatre, setSelectedTheatre] = useState("Bliss Theatre");
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const locations = Object.keys(THEATER_DATA);
  const currentTheatres = Object.keys(THEATER_DATA[selectedLocation] || {});

  const displayItems =
    activeTab === "theater"
      ? THEATER_DATA[selectedLocation]?.[selectedTheatre] || []
      : GAMES_DATA;

  const handleLocationChange = (e) => {
    const newLoc = e.target.value;

    setSelectedLocation(newLoc);
    setSelectedTheatre(Object.keys(THEATER_DATA[newLoc])[0]);
  };

  const handleTheatreChange = (e) => {
    setSelectedTheatre(e.target.value);
  };

  return (
    <>
      <style>{`
        .gallery-page {
          --primary: #4F46E5;
          --primary-dark: #4338ca;
          --primary-light: #e0e7ff;
          --primary-ultra-light: #EEF2FF;
          --text-dark: #0F172A;
          --text-gray: #64748B;
          --bg-page: #F8FAFC;
          --white: #FFFFFF;
          --radius-lg: 16px;
          --shadow-card: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03);
          --shadow-hover: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);

          width: 100%;
          box-sizing: border-box;
          background: var(--bg-page);
          color: var(--text-dark);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .gallery-page *,
        .gallery-page *::before,
        .gallery-page *::after {
          box-sizing: border-box;
        }

        .gallery-page .gallery-header {
          text-align: center;
          padding: 60px 20px 20px;
          max-width: 800px;
          margin: 0 auto;
        }

        .gallery-page .eyebrow {
          font-size: 13px;
          font-weight: 700;
          color: var(--primary);
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 12px;
          display: block;
        }

        .gallery-page .main-title {
          font-size: 50px;
          font-weight: 800;
          color: var(--text-dark);
          margin: 0 0 8px;
          line-height: 1.1;
        }

        .gallery-page .subtitle {
          font-size: 16px;
          color: var(--text-gray);
          margin-bottom: 32px;
          line-height: 1.7;
        }

        .gallery-page .toggle-container {
          display: flex;
          justify-content: center;
          gap: 0;
          margin: 0 auto 14px;
          background: #E2E8F0;
          padding: 4px;
          border-radius: 99px;
          width: fit-content;
          max-width: 100%;
        }

        .gallery-page .toggle-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 10px 28px;
          border-radius: 99px;
          border: none;
          background: transparent;
          color: var(--text-gray);
          font-weight: 600;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: inherit;
        }

        .gallery-page .toggle-btn.active {
          background: var(--primary);
          color: white;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        }

        .gallery-page .toggle-dot {
          width: 8px;
          height: 8px;
          flex-shrink: 0;
          border-radius: 50%;
          background: currentColor;
        }

        /* BLOG BUTTON — BELOW THEATER/GAMES TOGGLE */

        .gallery-page .gallery-blog-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          min-height: 44px;
          margin: 0 auto 4px;
          padding: 11px 24px;
          border: 1px solid rgba(79, 70, 229, 0.22);
          border-radius: 50px;
          background: #ffffff;
          color: #4338ca;
          font-family: inherit;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.15px;
          cursor: pointer;
          box-shadow: 0 5px 16px rgba(79, 70, 229, 0.07);
          transition:
            background 0.25s ease,
            color 0.25s ease,
            border-color 0.25s ease,
            transform 0.25s ease,
            box-shadow 0.25s ease;
        }

        .gallery-page .gallery-blog-button:hover {
          background: #4F46E5;
          color: #ffffff;
          border-color: #4F46E5;
          transform: translateY(-2px);
          box-shadow: 0 9px 22px rgba(79, 70, 229, 0.2);
        }

        .gallery-page .gallery-blog-button:focus-visible {
          outline: 3px solid rgba(79, 70, 229, 0.28);
          outline-offset: 4px;
        }

        .gallery-page .gallery-blog-button svg {
          flex-shrink: 0;
        }

        .gallery-page .filter-bar {
          max-width: 1100px;
          margin: 0 auto 40px;
          background: var(--white);
          padding: 12px;
          border-radius: 100px;
          display: flex;
          gap: 12px;
          box-shadow: var(--shadow-card);
          border: 1px solid rgba(0,0,0,0.04);
          animation: gallerySlideDown 0.4s ease-out;
        }

        @keyframes gallerySlideDown {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .gallery-page .custom-select-wrapper {
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: center;
          background: #F8FAFC;
          border-radius: 99px;
          padding: 8px 16px;
          position: relative;
          transition: background 0.2s;
          border: 1px solid transparent;
        }

        .gallery-page .custom-select-wrapper:hover {
          background: #F1F5F9;
        }

        .gallery-page .custom-select-wrapper:focus-within {
          background: white;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px var(--primary-light);
        }

        .gallery-page .select-icon-box {
          width: 32px;
          height: 32px;
          background: var(--primary);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          flex-shrink: 0;
        }

        .gallery-page .select-content {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow: hidden;
        }

        .gallery-page .select-label {
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          color: #94A3B8;
          margin-bottom: 2px;
        }

        .gallery-page .custom-select {
          border: none;
          background: transparent;
          font-size: 15px;
          font-weight: 600;
          color: var(--text-dark);
          width: 100%;
          cursor: pointer;
          appearance: none;
          outline: none;
          padding-right: 20px;
          font-family: inherit;
        }

        .gallery-page .select-arrow {
          position: absolute;
          right: 16px;
          color: #94A3B8;
          pointer-events: none;
        }

        .gallery-page .m-filter-bar {
          display: none;
        }

        .gallery-page .gallery-grid {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 24px;
          padding: 0 20px 60px;
        }

        .gallery-page .gallery-item {
          position: relative;
          border-radius: var(--radius-lg);
          overflow: hidden;
          aspect-ratio: 4 / 3;
          background: #000;
          cursor: pointer;
          box-shadow: var(--shadow-card);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .gallery-page .gallery-item:hover {
          transform: translateY(-4px);
          box-shadow: var(--shadow-hover);
        }

        .gallery-page .gallery-item img,
        .gallery-page .gallery-item video {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .gallery-page .gallery-item:hover img {
          transform: scale(1.05);
        }

        .gallery-page .gallery-item-label {
          position: absolute;
          bottom: 10px;
          left: 10px;
          background: rgba(0,0,0,0.6);
          backdrop-filter: blur(8px);
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          z-index: 2;
        }

        .gallery-page .play-overlay {
          position: absolute;
          inset: 0;
          background: rgba(15, 23, 42, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .gallery-page .gallery-item:hover .play-overlay {
          opacity: 1;
        }

        .gallery-page .play-btn {
          width: 56px;
          height: 56px;
          background: rgba(255,255,255,0.2);
          backdrop-filter: blur(4px);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          border: 1px solid rgba(255,255,255,0.4);
        }

        /* LIGHTBOX */

        .gallery-page .lightbox-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.95);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: galleryFadeIn 0.2s ease;
        }

        .gallery-page .lightbox-content {
          position: relative;
          max-width: 1200px;
          width: 100%;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .gallery-page .lb-media-container {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          touch-action: pan-y;
        }

        .gallery-page .lb-media {
          max-width: 100%;
          max-height: 75vh;
          border-radius: 12px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          object-fit: contain;
        }

        .gallery-page .lb-close {
          position: absolute;
          top: -50px;
          right: 0;
          background: rgba(255,255,255,0.1);
          border: none;
          color: white;
          cursor: pointer;
          padding: 10px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
        }

        .gallery-page .lb-close:hover {
          background: rgba(255,255,255,0.2);
        }

        .gallery-page .lb-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.1);
          border: none;
          color: white;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
        }

        .gallery-page .lb-nav:hover {
          background: rgba(255,255,255,0.2);
        }

        .gallery-page .lb-prev { left: -60px; }
        .gallery-page .lb-next { right: -60px; }

        .gallery-page .lb-desktop-counter {
          position: absolute;
          bottom: -40px;
          left: 50%;
          transform: translateX(-50%);
          color: rgba(255,255,255,0.6);
          font-size: 14px;
          font-weight: 500;
        }

        .gallery-page .lb-desktop-title {
          position: absolute;
          top: -50px;
          left: 0;
          background: rgba(255,255,255,0.1);
          padding: 6px 14px;
          border-radius: 20px;
          color: white;
          font-size: 13px;
          backdrop-filter: blur(4px);
        }

        .gallery-page .lb-dots {
          display: flex;
          gap: 6px;
          margin-top: 16px;
          justify-content: center;
        }

        .gallery-page .lb-dot {
          width: 8px;
          height: 8px;
          padding: 0;
          border: none;
          border-radius: 50%;
          background: rgba(255,255,255,0.3);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .gallery-page .lb-dot-active {
          background: white;
          width: 24px;
          border-radius: 4px;
        }

        .gallery-page .lb-mobile-bottom-bar {
          display: none;
        }

        @keyframes galleryFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        /* RESPONSIVE */

        @media (max-width: 768px) {
          .gallery-page .gallery-header {
            padding: 40px 16px 20px;
          }

          .gallery-page .main-title {
            font-size: 30px;
          }

          .gallery-page .subtitle {
            font-size: 14px;
            margin-bottom: 24px;
          }

          .gallery-page .toggle-btn {
            padding: 8px 22px;
            font-size: 13px;
          }

          .gallery-page .gallery-blog-button {
            min-height: 42px;
            padding: 10px 21px;
            font-size: 12px;
          }

          .gallery-page .filter-bar {
            display: none !important;
          }

          .gallery-page .m-filter-bar {
            display: flex;
            justify-content: center;
            gap: 0;
            margin: 0 16px 28px;
            background: var(--white);
            border-radius: 16px;
            padding: 16px 8px;
            box-shadow: 0 2px 12px rgba(0,0,0,0.06);
            border: 1px solid #E2E8F0;
            animation: gallerySlideDown 0.4s ease-out;
          }

          .gallery-page .m-filter-card {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 6px;
            position: relative;
            cursor: pointer;
            padding: 4px 2px;
          }

          .gallery-page .m-filter-card:not(:last-child)::after {
            content: '';
            position: absolute;
            right: 0;
            top: 8px;
            bottom: 8px;
            width: 1px;
            background: #E2E8F0;
          }

          .gallery-page .m-filter-icon-circle {
            width: 44px;
            height: 44px;
            border-radius: 14px;
            background: var(--primary-ultra-light);
            color: var(--primary);
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1.5px solid transparent;
          }

          .gallery-page .m-filter-label {
            font-size: 9px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            color: #94A3B8;
            line-height: 1;
          }

          .gallery-page .m-filter-value {
            font-size: 13px;
            font-weight: 800;
            color: var(--text-dark);
            text-align: center;
            line-height: 1.2;
            max-width: 90px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .gallery-page .m-filter-native-select {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
            font-size: 16px;
            appearance: none;
            z-index: 2;
          }

          .gallery-page .gallery-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 12px;
            padding: 0 16px 40px;
          }

          .gallery-page .gallery-item {
            border-radius: 12px;
          }

          .gallery-page .gallery-item-label {
            font-size: 10px;
            padding: 3px 8px;
            bottom: 6px;
            left: 6px;
          }

          .gallery-page .lightbox-overlay {
            padding: 0;
            align-items: flex-start;
          }

          .gallery-page .lightbox-content {
            max-width: 100%;
            max-height: 100vh;
            height: 100vh;
            border-radius: 0;
            justify-content: center;
          }

          .gallery-page .lb-media {
            max-height: 60vh;
            border-radius: 0;
            width: 100%;
          }

          .gallery-page .lb-close {
            position: fixed;
            top: 16px;
            right: 16px;
            background: rgba(255,255,255,0.15);
            backdrop-filter: blur(8px);
            z-index: 1010;
          }

          .gallery-page .lb-desktop-nav,
          .gallery-page .lb-desktop-counter,
          .gallery-page .lb-desktop-title {
            display: none !important;
          }

          .gallery-page .lb-mobile-bottom-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(15, 23, 42, 0.9);
            backdrop-filter: blur(16px);
            padding: 16px 20px;
            padding-bottom: max(16px, env(safe-area-inset-bottom));
            z-index: 1010;
            border-top: 1px solid rgba(255,255,255,0.08);
          }

          .gallery-page .lb-mobile-nav-btn {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(255,255,255,0.1);
            border: 1px solid rgba(255,255,255,0.15);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }

          .gallery-page .lb-mobile-counter-wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
          }

          .gallery-page .lb-mobile-title {
            font-size: 13px;
            font-weight: 700;
            color: white;
          }

          .gallery-page .lb-mobile-counter {
            font-size: 12px;
            color: rgba(255,255,255,0.5);
            font-weight: 500;
          }

          .gallery-page .lb-dots {
            position: fixed;
            bottom: 90px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1010;
          }
        }

        @media (max-width: 380px) {
          .gallery-page .m-filter-icon-circle {
            width: 38px;
            height: 38px;
            border-radius: 12px;
          }

          .gallery-page .m-filter-icon-circle svg {
            width: 16px;
            height: 16px;
          }

          .gallery-page .m-filter-value {
            font-size: 12px;
            max-width: 75px;
          }

          .gallery-page .m-filter-label {
            font-size: 8px;
          }

          .gallery-page .main-title {
            font-size: 26px;
          }

          .gallery-page .gallery-grid {
            gap: 8px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .gallery-page *,
          .gallery-page *::before,
          .gallery-page *::after {
            animation-duration: 0.01ms !important;
            transition-duration: 0.01ms !important;
          }
        }
      `}</style>

      <div className="gallery-page">
        {/* HEADER */}
        <header className="gallery-header">
          <span className="eyebrow">+ Premium Private Theatres</span>

          <h1 className="main-title">HexaPlay Gallery</h1>

          <p className="subtitle">
            Curated moments from our exclusive theatre experiences
          </p>

          {/* THEATRE / GAMES TOGGLE */}
          <div className="toggle-container">
            <button
              type="button"
              className={`toggle-btn ${activeTab === "theater" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("theater");
                setLightboxIndex(null);
              }}
              aria-pressed={activeTab === "theater"}
            >
              <span className="toggle-dot" />
              Theater
            </button>

            <button
              type="button"
              className={`toggle-btn ${activeTab === "games" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("games");
                setLightboxIndex(null);
              }}
              aria-pressed={activeTab === "games"}
            >
              <span className="toggle-dot" />
              Games
            </button>
          </div>

          {/* BLOG BUTTON — REDIRECTS TO /blog */}
          <button
            type="button"
            className="gallery-blog-button"
            onClick={() => navigate("/blog")}
            aria-label="Visit HexaPlay Blog"
          >
            <Icons.Blog />
            <span>Explore Our Blog</span>
            <span aria-hidden="true">↗</span>
          </button>
        </header>

        {/* DESKTOP FILTER BAR */}
        {activeTab === "theater" && (
          <div className="filter-bar">
            <CustomSelect
              label="Location"
              icon={Icons.MapPin}
              value={selectedLocation}
              onChange={handleLocationChange}
              options={locations}
              placeholder="Select Location"
            />

            <CustomSelect
              label="Select Theatre Name"
              icon={Icons.Camera}
              value={selectedTheatre}
              onChange={handleTheatreChange}
              options={currentTheatres}
              placeholder="Select your preferred theatre"
            />
          </div>
        )}

        {/* MOBILE FILTER BAR */}
        {activeTab === "theater" && (
          <div className="m-filter-bar">
            <MobileFilterCard
              icon={Icons.MapPin}
              label="LOCATION"
              value={selectedLocation}
              options={locations}
              onChange={handleLocationChange}
            />

            <MobileFilterCard
              icon={Icons.Camera}
              label="SELECT THEATRE"
              value={selectedTheatre}
              options={currentTheatres}
              onChange={handleTheatreChange}
            />
          </div>
        )}

        {/* GALLERY GRID */}
        <div className="gallery-grid">
          {displayItems.length > 0 ? (
            displayItems.map((item, index) => (
              <div
                key={`${activeTab}-${item.src}-${index}`}
                className="gallery-item"
                onClick={() => setLightboxIndex(index)}
                role="button"
                tabIndex={0}
                aria-label={`Open ${item.label || "gallery image"}`}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setLightboxIndex(index);
                  }
                }}
              >
                {item.type === "video" ? (
                  <>
                    <img
                      src={item.thumbnail}
                      alt={item.label || "Video thumbnail"}
                    />
                    <div className="play-overlay">
                      <div className="play-btn">
                        <Icons.Play />
                      </div>
                    </div>
                  </>
                ) : (
                  <img
                    src={item.src}
                    alt={item.label || "Gallery item"}
                    loading="lazy"
                  />
                )}

                {item.label && (
                  <span className="gallery-item-label">{item.label}</span>
                )}
              </div>
            ))
          ) : (
            <p
              style={{
                gridColumn: "1 / -1",
                textAlign: "center",
                color: "#64748B",
                padding: "30px 10px",
              }}
            >
              No images found for this selection.
            </p>
          )}
        </div>

        {/* LIGHTBOX */}
        {lightboxIndex !== null && (
          <Lightbox
            items={displayItems}
            initialIndex={lightboxIndex}
            onClose={() => setLightboxIndex(null)}
            title={activeTab === "theater" ? selectedTheatre : "Games Zone"}
          />
        )}
      </div>
    </>
  );
}
